import React from 'react';
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButton,
  FormControl,
  FormLabel,
} from '@mui/material';

import styles from './toggleButtonGroup.style';

const ToggleButtonGroup = ({
  title,
  options, //  array of { label: string, value: string }
  required = false,
  disabled = false,
  loading,
  value,
  onChange,
}) => {
  const handleChange = (event, newValue) => {
    onChange?.(newValue);
  };

  return (
    <FormControl
      sx={styles.wrapper}
      disabled={disabled || loading}
      required={required}
    >
      <FormLabel sx={styles.label}>{title}</FormLabel>
      <MuiToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        sx={styles.group}
        disabled={disabled || loading}
      >
        {options.map((choice) => (
          <ToggleButton
            key={choice.value}
            value={choice.value}
            sx={styles.button}
            disabled={disabled}
          >
            {choice.label}
          </ToggleButton>
        ))}
      </MuiToggleButtonGroup>
    </FormControl>
  );
};

export default ToggleButtonGroup;
